<template>
  <div class="activity_container">
    <div class="hd activity-background-color">
      <span class="icon icon-left navshare" @click="goBack"></span>
      <span class="header_title">援鄂医生认证</span>
    </div>
    <div class="box" v-show="hasLogin">
      <div class="progress-bar">
        <div class="progress-background">
          <div class="progress-ball" style="left: 0;"></div>
          <div style="position:absolute;left:0;" v-if="stage !== 1">
            <div class="progress-line" ></div>
            <div class="progress-ball" style="left:23.5vw;"></div>
          </div>
          <div style="position:absolute;left:25vw;" v-if="stage === 3 || stage === 4">
            <div class="progress-line" ></div>
            <div class="progress-ball" style="left:23.5vw;"></div>
          </div>
          <div style="position:absolute;left:50vw;" v-if="stage === 4">
            <div class="progress-line" ></div>
            <div class="progress-ball" style="left:23.5vw;"></div>
          </div>
        </div>

        <div class="progress-stage">
          <span class="progress-text">信息确认</span>
          <span class="progress-text">上传工牌</span>
          <span class="progress-text">自用或转赠</span>
          <span class="progress-text">完成认证</span>
        </div>
      </div>
      <div class="personal-detail" v-if="stage === 1">
        <div class="main-upload-container" style="height: 156px; align-items: flex-start;" v-if="hasLogin">
          <div class="activity-cell">
            <div class="cell-outer">
              <span class="attr-key">姓名</span> <span class="attr-value">{{customerName}}</span>
            </div>
          </div>
          <div class="activity-cell">
            <div class="cell-outer">
              <span class="attr-key">手机</span> <span class="attr-value">{{mobile}}</span>
            </div>
          </div>
          <div class="activity-cell">
            <div class="cell-outer">
              <span class="attr-key">单位</span> <span class="attr-value">{{enterpriseName}}</span>
            </div>
          </div>

        </div>
        <div class="button-group">
          <div class="button-wrap activity-background-color" style="width: 100%;" @click="goToNextStep()"><span class="button-name">下一步</span></div>
        </div>
      </div>
      <div class="upload-identification" v-if="stage === 2">
        <div class="main-upload-container" :style="'height: 206px;background-image:url(' + url + ');background-repeat:no-repeat;background-size:100% 100%;'">

          <div class="icon-container">
            <iframe src="/static/img/identification.svg" class="identity-icon" :style="ifShowIcon"></iframe>
            <input  type="file" id="imgFile" @change="changeImagePositive($event)" style="width:.5px;opacity:0;">
            <label for="imgFile" class="add-icon"></label>
          </div>
          <span class="upload-identification-instruction" v-if="!url">请上传您的工作证/学生证/身份证</span>
        </div>
        <div class="remind-info">注：由于微信浏览器的限制，部分机型可能出现无法上传照片的情况，请尝试点击右上角按钮，在其他浏览器中打开完成认证（需要重新登录）</div>
        <div class="button-group">
          <div class="button-up" style="width: 45%;" @click="goToLastStep()"><span class="button-name" >返回上一步</span></div>
          <div class="button-wrap activity-background-color" style="width: 45%;" @click="goToNextStep()"><span class="button-name">下一步</span></div>
        </div>
      </div>
      <div class="choose-discount-owner" v-if="stage === 3 && showSearchContact === false">
        <div class="choose-owner" @click="uploadIdentification(customerName, mobile)">
          <span class="discount-for">折扣券自用</span>
          <svg class="choose-icon" t="1583809028111" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path data-v-c24bfab2="" d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
        </div>
        <div class="choose-owner" @click="toggleShowSearchContact()">
          <span class="discount-for" style="color: #ff9400;">折扣券转赠</span>
          <svg class="choose-icon" t="1583809028111" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path data-v-c24bfab2="" d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
        </div>
        <div class="button-group">
          <div class="button-wrap activity-background-color" style="width: 100%;" @click="goToLastStep()"><span class="button-name">返回上一步</span></div>
        </div>
      </div>
      <div class="finish-process" v-if="stage === 4">

        <span class="first-line">您已经成功完成认证</span>
        <span class="second-line">奖励将在3-5个工作日内发送完毕</span>
        <div class="button-wrap activity-background-color" style="width: 87%;margin-top: 6.93vw;" @click="$router.push('/home')"><span class="button-name">返回主页</span></div>
      </div>
      <search-contact v-if="stage === 3 && showSearchContact" @finish="uploadIdentification" @toggleShow="toggleShowSearchContact()"></search-contact>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapState} from 'vuex'
import $ from 'jquery'
import SearchContact from './SearchContact'
// import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      stage: 1,
      url: '',
      showSearchContact: false
    }
  },
  mounted () {
    if (!this.hasLogin) {
      $.toast('请登录')
      return this.$router.push({name: 'login'})
    }
    this.checkIfUploadAlready()
  },
  components: {
    SearchContact
  },
  computed: {
    ...mapState([
      'sessionInfo'
    ]),
    ...mapGetters([
      'hasLogin', 'customerName'
    ]),
    ifShowIcon () {
      return 'visibility:' + (this.url ? 'hidden;' : 'visible;')
    },
    mobile () {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.mobile
    },
    enterpriseName () {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.enterpriseName
    },
    customerNo () {
      return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    changeImagePositive (e) {
      let file = e.target.files && e.target.files[0]
      if (!file) return
      let isAllowedUpdate = this.checkImage(file)
      if (!isAllowedUpdate) {
        return $.toast('上传图片过大')
      }
      this.imgFile = file
      let reader = new FileReader()
      let _this = this
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        _this.url = this.result
        console.log(file)
      }
    },
    checkImage (file) {
      let maxSize = 5 * 1024 // 5mb
      let size = file.size
      let isAllow = false
      maxSize = maxSize * 1024 // 转化为字节数
      isAllow = size <= maxSize
      return isAllow
    },
    goToNextStep () {
      if (this.stage === 2 && !this.url) return $.toast('请上传您的工牌')
      this.stage += 1
    },
    goToLastStep () {
      this.stage -= 1
    },
    toggleShowSearchContact () {
      this.showSearchContact = !this.showSearchContact
    },
    checkIfUploadAlready () {
      let formData = new FormData()
      let config = {
        'Content-Type': 'multipart/form-data'
      }
      let url = `/gcapi/formDataCollect/applyCustomerAdditionalinfos?customerNo=${this.customerNo}&activityName=援鄂活动`
      this.$http.post(url, formData, config).then((res) => {
        if (res.body.code === 0) {
          this.stage = 1 // 未上传过文件
        } else {
          this.stage = 4 // 已上传过文献
          $.toast('已完成认证')
        }
      }).catch(e => {
        console.log('error', e)
      })
    },
    uploadIdentification (queryName, queryMobile) {
      if (!this.imgFile) return $.toast('请上传身份证明')
      $.showPreloader('上传中')
      console.log('uploadIdentification')
      let formData = new FormData()
      formData.append('positive', this.imgFile)
      let config = {
        'Content-Type': 'multipart/form-data'
      }
      let url = `/gcapi/formDataCollect/applyCustomerAdditionalinfos?customerNo=${this.customerNo}&activityName=援鄂活动`
      this.$http.post(url, formData, config).then((res) => {
        if (res.body.code === 0) {
          this.saveInfoCollectionIntoDB(queryName, queryMobile)
        } else {
          $.toast(res.body.message)
        }
      }).catch(e => {
        console.log('error', e)
      })
    },
    saveInfoCollectionIntoDB (queryName, queryMobile) {
      const formCollectionActivity = {
        'customerNo': this.customerNo,
        'customerMobile': this.mobile,
        'customerName': this.customerName,
        'customerEnterpriseName': this.enterpriseName,
        'activityName': '援鄂活动',
        'additionalinfos': []
      }
      formCollectionActivity['additionalinfos'].push({
        'columnName': '券是否自用',
        'columnValue': queryMobile === this.mobile ? '券自用' : '券赠送'
      })
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者电话号码',
        'columnValue': queryMobile
      })
      formCollectionActivity['additionalinfos'].push({
        'columnName': '持券者姓名',
        'columnValue': queryName
      })
      const formCollectionActivityList = []
      formCollectionActivityList.push(formCollectionActivity)
      this.gcapi('submitFormCollectionActivity', formCollectionActivityList).then((response) => {
        $.hidePreloader()
        // 如果转赠，发送注册短信
        if (queryMobile !== this.mobile) {
          this.sendRegistrationText(queryName, queryMobile)
        }
        this.goToNextStep()
      })
    },
    sendRegistrationText (name, mobile) {
      let textString = `${name}老师，您好！您的好友${this.customerName}老师因为参与援鄂活动，享受吉凯基因提供的专属「定制产品6折券」，他已经将该福利赠与您使用，您可以登录吉凯淘基因商城www.taogene.com查看福利并使用`
      const queryParam = {}
      queryParam.mobile = mobile
      queryParam.message = textString
      this.gcapi('@gcwwwifc/requestRegiserInvitation', queryParam).then((res) => {
        if (res && res.body.code === 0) return $.toast('发送成功')
        return $.toast('发送失败')
      })
    }
  }
}
</script>
<style scoped>


html, body {
  height: 100%;
}
/*header*/
.activity-background-color {
  background-color: #5878fa;
}
.activity_container {
  /*overflow-y:scroll;*/
  /*overflow:hidden;*/
  /*-webkit-overflow-scrolling:touch;*/
  /*height:100%;*/
}

.box {
   display: flex;
   position: relative;
   align-items: center;
   flex-direction: column;
   background-color: #efeef3;
   width: 100vw;
   height: 100vh;
   top: 14.93vw;
   left: 0;
    padding: 0 8vw;
 }

.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

input::-webkit-input-placeholder {
  text-align: start;
  color: #D5D5D5;
}


/*progress-bar*/
.progress-bar {
  width: 100%;
  height: 20vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.progress-background {
  position: relative;
  margin-top: 7.2vw;
  border-top-width: 4px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 75vw;
}
.progress-line {
  position: absolute;
  border-top-width: 4px;
  border-top-style: solid;
  border-top-color: #5878fa;
  width: 25vw;
  top: -3.5px;;
}

.progress-ball {
  position: absolute;
  top: -1.8vw;
  border-radius: 50%;
  background-color: #5878fa;
  width: 3vw;
  height: 3vw;
}

.progress-stage {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 4vw;
  height: 5.33vw;
  width: 100%;
}

.progress-text {
  opacity: 1;
  /*margin-right: 12.27vw;*/
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}





/*personal-detail*/
.personal-detail {
  width: 100%;
}
.main-upload-container {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  margin-top: 5.07vw;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 100%;
  height: 41.07vw;
  /*margin: 0 auto*/
}

.activity-cell {
  box-sizing: border-box;
  height: 52px;
  width: 100%;
  padding: 0 24px;

}
.cell-outer {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  border-bottom: 0.7px solid rgba(213, 213, 213, 1)
}
.activity-cell:last-child .cell-outer{
  border: 0;
}

.attr-key {
  opacity: 1;
  line-height: 20px;
  white-space: nowrap;
  color: #424242;
  font-size: 14px;
  font-weight: 500;
  width: 75px;
}

.attr-value {
  opacity: 1;
  line-height: 20px;
  white-space: nowrap;
  color: #929292;
  font-size: 14px;
  font-weight: 400;
  max-width: 210px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.button-wrap {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  height: 13.33vw;
  color: #fff;
}


.button-name {
  opacity: 1;
  width: 100%;
  height: 5.33vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  /*color: #ffffff;*/
  font-size: 3.73vw;
  font-weight: 400;
}

/*upload-identification*/
.upload-identification {
  width: 100%;
}
.icon-container {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 58px;
  width: 228px;
  height: 87px;
}

.identity-icon {
  width: 138px;
  height: 87px;
  border-width: 0;
}

.add-icon {
  width: 40px;
  height: 40px;
  border-width: 0;
  background-image: url('/static/img/add.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.upload-identification-instruction {
  position: relative;
  opacity: 1;
  margin-top: 20px;
  max-width: 268px;
  height: 20px;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 20px;
  white-space: nowrap;
  color: #d5d5d5;
  font-size: 14px;
  font-weight: 500;
}
.button-group {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 6.67vw;
  border-radius: 2.67vw;
  width: 100%;
  height: 13.33vw;
}
.button-up {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  height: 13.33vw;
  background-color: #fff;
  color: #5878fa;
}
.remind-info {
  margin-top: 15px;
  color: #929292;
  font-size: 12px;
  font-weight: normal;
  line-height: 25px;
}
/*choose-discount-owner*/
.choose-owner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-top: 5.07vw;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  height: 26.67vw;
}

.discount-for {
  opacity: 1;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #5878fa;
  font-size: 4.8vw;
  font-weight: 400;
}


.choose-icon {
  width: 5vw;
  height: 5vw;
  position: absolute;
  right: 13vw;
}

  /*finish-process*/
  .finish-process {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 4.8vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 100%;
    height: 44.53vw;
  }

  .first-line {
    opacity: 1;
    margin-top: 6.4vw;
    max-width: 62.67vw;
    height: 5.33vw;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 4.27vw;
    font-weight: 500;
  }

  .second-line {
    position: relative;
    opacity: 1;
    margin-top: 0.53vw;
    max-width: 74.93vw;
    height: 5.33vw;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 4.27vw;
    font-weight: 500;
  }

</style>



// WEBPACK FOOTER //
// ActivityDoctor.vue?c75027dc